"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "title": "Finder",
  "subtitle": "Ola Nordmann",
  "primaryAction": {
    "label": "Create",
    "children": [{
      "label": "Create X"
    }, {
      "label": "Create Y"
    }]
  },
  "menu": [{
    "label": "Menu 1",
    "children": [{
      "label": "Submenu 1"
    }, {
      "label": "Submenu 2"
    }]
  }, {
    "label": "Menu 2"
  }],
  "search": {
    "placeholder": "Søk i app"
  },
  "sidebar": {
    "expanded": true
  }
};
exports.default = _default;
module.exports = exports.default;